import { record_type, tuple_type, option_type, float64_type, union_type, class_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { Record, Union } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { PickedMapValueProps, MapValuePickedArgs_$reflection } from "./PickedMapValueBindings.js";
import { ViewportLocation_parse_Z721C83C5, ViewportLocation_$reflection } from "../Common/CommonTypes.js";
import { DisplayMap_get_tryGetUnits, DisplayMap_$reflection } from "../Common/CommonBindings.js";
import { wrapInboundMsg } from "../../Common/InboundOutbound.js";
import { FSharpMap__get_Item } from "../../fable_modules/fable-library-js.4.19.3/Map.js";
import { ofArray, toArray } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { defaultArg, map, toArray as toArray_1 } from "../../fable_modules/fable-library-js.4.19.3/Option.js";
import { printf, interpolate, toText } from "../../fable_modules/fable-library-js.4.19.3/String.js";
import { NotesProps, StaticLabel } from "../Notes/NotesBindings.js";

export class LocalMsg {
    constructor() {
    }
}

export function LocalMsg_$reflection() {
    return class_type("RAWMap.Client.Visualization.PickedMapValue.Types.LocalMsg", undefined, LocalMsg);
}

export class InboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["MapValuePicked", "ClearPickedValues"];
    }
}

export function InboundMsg_$reflection() {
    return union_type("RAWMap.Client.Visualization.PickedMapValue.Types.InboundMsg", [], InboundMsg, () => [[["Item", MapValuePickedArgs_$reflection()]], [["Item", ViewportLocation_$reflection()]]]);
}

export class OutboundMsg {
    constructor() {
    }
}

export function OutboundMsg_$reflection() {
    return class_type("RAWMap.Client.Visualization.PickedMapValue.Types.OutboundMsg", undefined, OutboundMsg);
}

export class ModelPickedMapValue extends Record {
    constructor(PickedMapValues, LabelId) {
        super();
        this.PickedMapValues = PickedMapValues;
        this.LabelId = LabelId;
    }
}

export function ModelPickedMapValue_$reflection() {
    return record_type("RAWMap.Client.Visualization.PickedMapValue.Types.ModelPickedMapValue", [], ModelPickedMapValue, () => [["PickedMapValues", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [ViewportLocation_$reflection(), tuple_type(DisplayMap_$reflection(), option_type(float64_type))])], ["LabelId", class_type("System.Guid")]]);
}

export function ModelPickedMapValue_Props(model, viewportLocation, dispatch) {
    let patternInput;
    return new PickedMapValueProps((arg_2) => {
        dispatch(wrapInboundMsg(new InboundMsg(0, [arg_2])));
    }, new NotesProps((patternInput = FSharpMap__get_Item(model.PickedMapValues, viewportLocation), toArray(ofArray(toArray_1(map((pickedValue) => {
        let option, clo;
        return new StaticLabel(model.LabelId, toText(interpolate("Point value: %0.2f%P()%P()", [pickedValue, defaultArg((option = DisplayMap_get_tryGetUnits()(patternInput[0]), map((clo = toText(printf(" %s")), clo), option)), "")])), 0, 0.05, 0.25, undefined, undefined, false, false);
    }, patternInput[1]))))), (x_1) => x_1, [], (value_1) => {
    }), (arg_5) => {
        dispatch(wrapInboundMsg(new InboundMsg(1, [ViewportLocation_parse_Z721C83C5(arg_5)])));
    });
}

